var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgReportWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "118px",
    viewBox: "0 0 104 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C49.673112,0 64,14.360362 64,32.0747664 C64,41.7358195 59.7386452,50.3992543 52.9971751,56.2796696 L32.0500895,78 L11.048967,56.3198412 C4.28080533,50.4387475 0,41.7578428 0,32.0747664 C0,14.360362 14.326888,0 32,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-37.5%",
    y: "-37.6%",
    width: "175.0%",
    height: "175.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7AD9\\u70B9\\u5730\\u56FE3\\u5907\\u4EFD",
    transform: "translate(-263.000000, -1180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(283.000000, 1192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F25643",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u611F\\u53F9\\u53F7\\u5907\\u4EFD-2",
    filter: "url(#filter-3)",
    transform: "translate(16.000000, 16.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32,
    height: 31.9169995
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.353125,24.1621661 L18.428125,5.29248684 C17.09375,2.98598492 14.909375,2.98598492 13.571875,5.29248684 L2.65,24.1621661 C1.3125,26.4717849 2.40625,28.3543891 5.075,28.3543891 L26.925,28.3543891 C29.59375,28.3543891 30.6875,26.4717849 29.353125,24.1621661 Z M17.353125,24.1871012 C17.0625,24.4707386 16.728125,24.6421678 16.35625,24.7076226 C16.2375,24.7138564 16.121875,24.7169733 16,24.7169733 C15.878125,24.7169733 15.7625,24.7138564 15.64375,24.7076226 C15.26875,24.6421678 14.9375,24.4676217 14.646875,24.1871012 C14.26875,23.8161908 14.08125,23.3735917 14.08125,22.8468366 C14.08125,22.3263152 14.26875,21.8743655 14.646875,21.4972213 C15.025,21.120077 15.478125,20.9299465 16,20.9299465 C16.521875,20.9299465 16.975,21.120077 17.353125,21.4972213 C17.73125,21.8743655 17.91875,22.3263152 17.91875,22.8468366 C17.921875,23.3704749 17.734375,23.8193077 17.353125,24.1871012 Z M16.91875,19.7829293 L15.115625,19.7829293 C14.896875,17.1211014 14.084375,13.4618673 14.084375,12.9631642 C14.084375,12.3927725 14.2625,11.9127707 14.621875,11.5262758 C14.984375,11.136664 15.440625,10.9402996 16.003125,10.9402996 C16.5625,10.9402996 17.021875,11.1335471 17.384375,11.5169251 C17.74375,11.90342 17.921875,12.3834218 17.921875,12.9631642 C17.921875,13.4618673 17.171875,17.1211014 16.91875,19.7829293 L16.91875,19.7829293 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgReportWarning);
export default __webpack_public_path__ + "static/media/img_report_warning.64e2c0f6ad99f7bd66164c1327ce90da.svg";
export { ForwardRef as ReactComponent };